module.exports = __webpack_public_path__ + "static/media/ic-persons.06dcc1f8.svg";